package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagDe: ImageVector
    get() {
        if (_flagDe != null) {
            return _flagDe!!
        }
        _flagDe = Builder(name = "FlagDe", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 170.7f)
                    lineTo(0.0f, 170.7f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFDD0000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 170.7f)
                    lineTo(512.0f, 170.7f)
                    lineTo(512.0f, 341.3f)
                    lineTo(0.0f, 341.3f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFCE00)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 341.3f)
                    lineTo(512.0f, 341.3f)
                    lineTo(512.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    close()
                }
            }
        }
        .build()
        return _flagDe!!
    }

private var _flagDe: ImageVector? = null
